import { takeEvery, select, put, call } from 'redux-saga/effects'
import { OBJECT_SILENT } from '../../../../store/Settings/sets'
import { loading } from '../../../../store/Settings/actions'
import { LOAD_ITEMS, putItems } from '../../../../store/Settings/actions/sets/Object/Silent'
import { buildGETUrl } from '../../../../utilities/buildGETUrl'
import { generateStateKey } from '../../../../utilities/generateStateKey'
import { showAlertError } from '../../../../store/Alert/actions'
import axios from 'axios'

export default function* () {
    yield takeEvery(LOAD_ITEMS, worker)
}

function* worker({ payload }) {
    const { stateKey, required } = payload

    try {
        const __itemsLoaded = yield select(state => state.settings.settings[OBJECT_SILENT][stateKey]?.__itemsLoaded)
        const selectedObjects = yield select(state => state.objects.selected || [])
        const selectedObjectsGroup = yield select(state => state.objectsGroup.selected || [])
        const selected = selectedObjectsGroup.length > 0 ? selectedObjectsGroup : selectedObjects

        if (selected.length) {
            if (required || __itemsLoaded !== true) {
                yield put(loading({
                    type: OBJECT_SILENT,
                    stateKey,
                    loading: true,
                }))

                const fetchedItems = yield call(fetchItems, selected)

                // Ошибка
                if (fetchedItems.error) {
                    yield put(showAlertError({
                        errors: [`Ошибка сервера при ${LOAD_ITEMS}.`, fetchedItems],
                        text: "Список Молчание не был загружен. Попробуйте повторить."
                    }))

                    // Успех
                } else {
                    const bufferStateKey = generateStateKey([stateKey, 0])

                    let items = fetchedItems.success,
                        assocItems = {
                            [bufferStateKey]: {
                                "fromdate": "",
                                "todate": "",
                            }
                        }

                    items.map(item => {
                        const itemStateKey = generateStateKey([stateKey, item.id])
                        assocItems[itemStateKey] = item
                    })

                    yield put(putItems({
                        stateKey,
                        items,
                        assocItems
                    }))
                }
            }
        }
    }

    // Ошибка
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${LOAD_ITEMS}.`, e],
            text: "Список Молчание не был загружен. Попробуйте повторить."
        }))
    }
    finally {
        yield put(loading({
            type: OBJECT_SILENT,
            stateKey,
            loading: false,
        }))
    }
}

function fetchItems(ms_id) {
    //ms_id = ms_id.join(",")
    return axios.get("/msbox/silent/select", { params: { ms_id } })
        .then(response => response.data)
}